// extracted by mini-css-extract-plugin
module.exports = {"title":"Content_title__BzdwJ","paragraph":"Content_paragraph__wsdjJ","list":"Content_list__7Rfa5","listItem":"Content_listItem__iV6UW"};